enum EnumEvent {
  ENTER = 'ENTER',
  EDIT = 'EDITING',
  DISCONNECT = 'DISCONNECT',
  ping = 'PING',
}
export { EnumEvent };
